import { Link } from "wouter";
import { ArrowRight } from "lucide-react";
import { caseStudies, findCaseStudy } from "@/data/case-studies";

export function CaseStudyPreview({ slugs, title = "From recent projects" }: { slugs?: string[]; title?: string }) {
  const list = slugs ? slugs.map(findCaseStudy).filter((s): s is NonNullable<typeof s> => !!s) : caseStudies;
  return (
    <section className="py-10 lg:py-14" aria-labelledby="case-preview-title" data-testid="section-case-study-preview">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex items-end justify-between gap-4 mb-5">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">Case studies</p>
            <h2 id="case-preview-title" className="font-display font-bold text-2xl md:text-3xl">{title}</h2>
          </div>
          <Link href="/case-studies" className="text-sm font-semibold text-primary hover:underline shrink-0" data-testid="link-preview-all-case-studies">All case studies</Link>
        </div>
        <div className={`grid gap-4 ${list.length > 2 ? "md:grid-cols-2 lg:grid-cols-3" : list.length > 1 ? "md:grid-cols-2" : ""}`}>
          {list.map(s => (
            <Link key={s.slug} href={s.path} data-testid={`link-preview-${s.slug}`} className="group relative block overflow-hidden rounded-2xl bg-slate-900 text-white min-h-[220px]">
              <img src={s.image} alt={s.imageAlt} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-70 transition-transform duration-500 group-hover:scale-[1.04]" />
              <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-slate-950/95 via-slate-950/50 to-transparent" />
              {s.stageNote && <span className="absolute left-4 top-4 rounded-full bg-slate-950/80 text-[0.68rem] font-semibold uppercase tracking-wider px-2.5 py-1">Installation stage</span>}
              <div className="relative h-full flex flex-col justify-end p-5 min-h-[220px]">
                <p className="text-xs uppercase tracking-[0.16em] text-white/70 mb-1">{s.client} {s.location} · {s.service}</p>
                <p className="font-display font-bold text-xl leading-tight mb-2">{s.shortTitle}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold">View photographs <ArrowRight aria-hidden className="w-4 h-4 transition-transform group-hover:translate-x-1" /></span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
